import React from 'react'
import styled from 'styled-components'

// Components
import Icon, { IconProps } from './Icon'

// Styles
import { fastTransition } from '../../styles/effects'

interface IIconContainer extends IconProps {
  // A theme-token key OR a raw CSS colour string — the Container below resolves a
  // key via theme.colors and otherwise uses the value as a literal colour.
  backgroundColor?: string
  padding?: string
  disabled?: boolean
  className?: string
}

const IconContainer: React.FC<IIconContainer> = (props) => {
  return (
    <Container
      className={props.className}
      backgroundColor={props.backgroundColor}
      padding={props.padding}
      disabled={props.disabled}
    >
      <Icon {...props} />
    </Container>
  )
}

export const Container = styled.span<{
  backgroundColor?: string
  padding?: string
  disabled?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ padding }) => padding || '12px'};
  transition: background-color ${fastTransition};
  border-radius: 4px;
  background-color: ${({ theme, backgroundColor }) =>
    (backgroundColor && theme.colors[backgroundColor]) ||
    backgroundColor ||
    theme.colors.textLightest};
  margin-right: ${({ padding }) =>
    padding ? `calc(${padding} + 2px)` : '12px'};
  width: max-content;
  height: fit-content;
  opacity: ${({ disabled }) => (disabled ? '0.6' : '1')};
`
export default IconContainer
